package com.solevo.dist.application.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant

data class Invoice(
    val invoiceId: String = "",
    val invoiceNumber: String = "",
    val legalEntityId: String? = null,
    val customerId: String = "",
    val orderId: String = "",
    val dueDate: Instant = Clock.System.now(),
    val created: Instant = Clock.System.now(),
    val totalPrice: Double = 0.0,
    val paid: Double = 0.0,
    val remaining: Double = 0.0,
    val invoiceLines: List<InvoiceLines> = listOf(),
    val docMetadata: DocMetadata? = DocMetadata(),
)

data class InvoiceLines(
    val id: String? = "",
    val invoiceId: String? = null,
    val productId: String? = "",
    val description: String? = "",
    val quantity: Double = 0.0,
    val pricePerUnit: Double = 0.0,
    val totalPrice: Double = 0.0,
    val unit: String? = "",
    val invoiceNumber: String? = "",
    val lineNumber: Double = 0.0
)
